(function() {
  $(document).on('ajaxError', function(_, xhr, settings) {
    if (xhr.status === 500 && settings.crossDomain === false) {
      window.location = '/500.html';
    }
  });
}());
